var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { theme } from '../../theme';
import { LegacyQuoteRetrievalBreadcrumb } from './LegacyQuoteRetrievalBreadcrumb';
var LegacyQuoteRetrievalBreadcrumbsStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 194px;\n  background-color: ", ";\n  position: relative;\n"], ["\n  display: flex;\n  width: 194px;\n  background-color: ", ";\n  position: relative;\n"])), function (props) { return (props.backgroundColor ? props.backgroundColor : theme.primaryColours.aubergine.main); });
export var LegacyQuoteRetrievalBreadcrumbs = function (_a) {
    var _b = _a.breadcrumbs, breadcrumbs = _b === void 0 ? [] : _b, backgroundColor = _a.backgroundColor;
    return (_jsx(LegacyQuoteRetrievalBreadcrumbsStyled, __assign({ backgroundColor: backgroundColor }, { children: breadcrumbs.map(function (breadcrumb) { return (_jsx(LegacyQuoteRetrievalBreadcrumb, __assign({}, breadcrumb))); }) })));
};
var templateObject_1;
